import {
  FORM_CONSTANTS,
  FORM_FILTERS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { QuerySend } from "@/shared/models/FormQuerySend";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { Rule } from "@/modules/ServiceTemplate/models/Rule";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import { USER_CONSTANTS } from "@/modules/User/constants/UserConstants";
import {
  SERVICE_TEMP_CONSTANTS,
  SERVICE_TEMP_EVENTS
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { TaskRule } from "@/modules/ServiceTemplate/models/TaskRule";
import { TASK_CONSTANTS } from "@/modules/Tasks/constants/TaskConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import GenericSearchBar from "../GenericSearchBar/GenericSearchBar.vue";
import lodash from "lodash";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { ACTIVE } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "@/shared/constants/GeneralConstants";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { TaskService } from "@/modules/Tasks/services/TaskService";

Vue.use(Vuetify);

@Component({
  name: "AddFormTemplate",
  components: {
    EmptyState,
    GenericSearchBar
  }
})
export default class AddFormTemplate extends Vue {
  @Prop() private dialogFormTemplate!: boolean;
  @Prop() private newRule!: Rule;
  @Prop() private userRoleList!: RoleInfo[];
  @Prop() private task!: TaskRule;
  @Prop() private showRoleList!: boolean;
  @Prop() private responsible!: string[];

  @Inject() formTemplateService!: FormTemplateService;
  @Inject() taskService!: TaskService;

  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  REQUIRED_TEXT = FORM_MESSAGES.REQUIRED_FIELD;
  USER_ROL = USER_CONSTANTS.LABEL.USER_ROL;
  SEARCH_TEXT = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.SEARCH;
  SELECTED_TEXT = SERVICE_TEMP_CONSTANTS.SELECTED_FORMS;
  cardClass = STYLE_CLASSES.CARD;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  roundBtnClassSecondary = STYLE_CLASSES.SECONDARY_ROUND_BTN;
  rowForms = STYLE_CLASSES.ROW_FORMS;
  formTemplatesSelected: Array<SectionGroupDetail> = [];
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  SEARCH_ADD_FORM_TEMPLATE_KEY = NAME_FINDERS.ADD_FORM_TEMPLATE;

  formTempDataList: Array<FormStatus> = [];
  filterQueryForms: QuerySend = {};
  loadingData = false;
  filterItems: {
    name?: string[];
    category?: string[];
  } = {};
  filterArray: Filter[] = lodash.cloneDeep(FORM_FILTERS) as Filter[];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  userRole: RoleInfo = this.userRoleList[0];
  currentStep = 1;
  showCardsContainer = false;
  lastFormRef = "";

  get titleNameRole(): string {
    return `${SERVICE_TEMP_CONSTANTS.TITLE.ADD_FORM_TEMP_TITLE} ${this.userRole.name}`;
  }

  @Watch("dialogFormTemplate")
  async open() {
    if (this.newRule && this.newRule.actions?.task?.formTemplates) {
      this.formTemplatesSelected = [
        ...(this.newRule.actions.task.formTemplates as Array<
          SectionGroupDetail
        >)
      ];
    } else if (this.task && this.task.formTemplates) {
      this.formTemplatesSelected = [
        ...(this.task.formTemplates as Array<SectionGroupDetail>)
      ];
    }
  }

  close(action: string) {
    if (action === "save") {
      if (this.newRule && this.newRule.actions?.task) {
        this.newRule.actions.task.formTemplates = this.formTemplatesSelected.slice();
      } else if (this.task) {
        this.task.formTemplates = this.formTemplatesSelected.slice();
      }
    }
    this.$emit(SERVICE_TEMP_EVENTS.CLOSE_MODAL_ADD_SECTION_GROUP);
  }

  async getFormsFilterEvents(data: any) {
    delete data["mainFilterKey"];
    this.filterItems = data;
    this.lastFormRef = "";
    await this.searchTemplates(false);
  }

  async searchTemplates(shouldPaginate?: boolean) {
    try {
      if (!shouldPaginate) this.loadingData = true;

      this.filterQueryForms = {
        state: FORM_CONSTANTS.STATE.ACTIVE,
        paginatedResult: true
      };

      if (this.filterItems.name)
        this.filterQueryForms.name = this.filterItems.name[0];

      if (this.filterItems.category)
        this.filterQueryForms.category = this.filterItems.category[0];

      if (this.lastFormRef) {
        this.filterQueryForms.docref = this.lastFormRef;
      }

      const formTempList = await this.formTemplateService.getFormTemplateWithFilters(
        this.filterQueryForms
      );

      if (formTempList.code === Http.Found && formTempList.data !== undefined) {
        const formList = formTempList.data.data;
        this.lastFormRef = formTempList.data.docref;
        this.showCardsContainer = true;
        if (shouldPaginate) {
          this.formTempDataList = [...this.formTempDataList, ...formList];
        } else {
          this.formTempDataList = formList;
        }
      } else {
        if (!shouldPaginate) {
          this.formTempDataList = [];
          this.showCardsContainer = false;
        }
        if (formTempList.code === Http.NotFound)
          Snackbar.popInfo(FORM_MESSAGES.NOT_FOUND_TEMPLATES);
        else Snackbar.popError(formTempList.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }

    this.loadingData = false;
  }

  async addForm(index: number) {
    if (this.formTempDataList[index].state === ACTIVE) {
      const newFormTemp = {
        name: this.formTempDataList[index].name,
        id: this.formTempDataList[index]._key,
        icon: this.formTempDataList[index].icon,
        required: false,
        idRole: this.userRole.id
      };

      let existFormTemp;

      if (this.formTemplatesSelected.length > 0) {
        existFormTemp = this.formTemplatesSelected.find(
          (formTemp: SectionGroupDetail) =>
            formTemp.id === this.formTempDataList[index]._key
        );
      }

      if (!existFormTemp) {
        if (this.formTemplatesSelected.length > 0 && this.task) {
          Snackbar.popInfo(TASK_CONSTANTS.MESSAGES.NO_MORE);
        } else {
          try {
            this.formTemplatesSelected.push(newFormTemp);
            Snackbar.popSuccess(SERVICE_TEMP_CONSTANTS.MESSAGES.ADD_FORM);
          } catch (error) {
            Snackbar.popError(SERVICE_TEMP_CONSTANTS.MESSAGES.INACTIVE_FORM);
            return;
          }
        }
      } else {
        Snackbar.popInfo(SERVICE_TEMP_CONSTANTS.MESSAGES.EXIST_FORM);
      }
    } else {
      Snackbar.popError(SERVICE_TEMP_CONSTANTS.MESSAGES.INACTIVE_FORM);
    }
  }

  removeForm(index: number) {
    this.formTemplatesSelected.splice(index, 1);
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  changeRole(obj: any, idRole: string) {
    if (obj.added) {
      const refArray = this.formTemplatesSelected.findIndex(
        e => e.id === obj.added.element.id
      );
      if (refArray >= 0) this.formTemplatesSelected[refArray].idRole = idRole;
    }
  }

  async onBottomFormsScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchTemplates(true);
    }
  }
}
